// src/services/insurance-storage.service.ts

export const INSURANCE_STORAGE_KEYS = {
  CLAIMS: "insurance_claims",
  POLICIES: "insurance_policies",
  ENROLLMENTS: "insurance_enrollments",
  AUTHORIZATIONS: "insurance_authorizations",
  PROVIDERS: "insurance_providers",
  ACTIVITY_LOGS: "insurance_activity_logs",
  ELIGIBILITY_VERIFICATIONS:
    "insurance_eligibility_verifications",
  REPORTS: "insurance_reports",
} as const;

export type InsuranceStorageKey =
  (typeof INSURANCE_STORAGE_KEYS)[keyof typeof INSURANCE_STORAGE_KEYS];

export function loadInsuranceData<T>(
  key: InsuranceStorageKey,
  fallback: T
): T { return fallback; }

export function saveInsuranceData<T>(
  key: InsuranceStorageKey,
  value: T
): void { /* Business records require backend persistence. */ }

export function clearInsuranceStorage(): void {
  Object.values(
    INSURANCE_STORAGE_KEYS
  ).forEach((key) => {
    localStorage.removeItem(key);
  });
}